import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "vp-theme-container",
  "vp-container": ""
}
const _hoisted_2 = { class: "page" }
const _hoisted_3 = { "vp-content": "" }

import { useThemeLocaleData } from '@theme/useThemeData'
import { RouteLink, useRouteLocale } from 'vuepress/client'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const routeLocale = useRouteLocale()
const themeLocale = useThemeLocaleData()

const messages = themeLocale.value.notFound ?? ['Not Found']
const getMsg = (): string =>
  messages[Math.floor(Math.random() * messages.length)]
const homeLink = themeLocale.value.home ?? routeLocale.value
const homeText = themeLocale.value.backToHome ?? 'Back to home'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", null, "404", -1)),
        _createElementVNode("blockquote", null, _toDisplayString(getMsg()), 1),
        _createVNode(_unref(RouteLink), { to: _unref(homeLink) }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(homeText)), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})